module.exports = __webpack_public_path__ + "media/images/client-5-f5c1d69eb21cabd1a07d36450fa5cfca.png";